import React from "react";
import { Blocks } from "./../../";

function Sidebar({ blocks }) {
	return (
		<aside id="sidebar">
			{blocks
				.filter((a_sidebar) =>
					Array.isArray(
						a_sidebar?.relationships?.field_sidebar_components?.data
					)
				)
				.map((a_sidebar) => {
					return (
						<Blocks
							data={a_sidebar.relationships.field_sidebar_components.data}
							isSidebar
							key={a_sidebar.id}
						/>
					);
				})}
		</aside>
	);
}

export default Sidebar;
